import { EnergyType } from '../../EnergyFlow'
import { InefficientParameters } from '../../../generated/graphql'
import {
  createHourlyRequirementFrom,
  createHourlyWasteFrom,
  HourlyEnergyFlow,
} from '../../HourlyEnergyFlow'
import {
  SingleTypeHourlyVariables,
  SingleTypeProvider,
} from './SingleTypeProvider'

/**
 * Fully provides for the demand.
 * Consumption depends on efficiency.
 * Efficiency losses are converted to waste.
 */
export abstract class InefficientProvider extends SingleTypeProvider<InefficientParameters> {
  protected provideForHour({
    remainingDemand,
  }: SingleTypeHourlyVariables): HourlyEnergyFlow[] {
    const { efficiency } = this.parameters

    const consumptionFactor = 1 / efficiency
    const wasteFactor = (1 - efficiency) / efficiency

    const provided = remainingDemand

    const externalConsumption = createHourlyRequirementFrom(
      provided,
      this.mapDemandToRequirementEnergyType(provided),
      provided.value * consumptionFactor,
    )

    const wasted =
      wasteFactor > 0
        ? createHourlyWasteFrom(
            provided,
            this.mapDemandToWasteEnergyType(provided),
            provided.value * wasteFactor,
          )
        : undefined

    return [provided, externalConsumption, ...(wasted ? [wasted] : [])]
  }

  protected abstract mapDemandToRequirementEnergyType(
    demand: HourlyEnergyFlow,
  ): EnergyType

  protected abstract mapDemandToWasteEnergyType(
    demand: HourlyEnergyFlow,
  ): EnergyType
}
